// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as GuidelinesRouteRouteImport } from './routes/guidelines/route'
import { Route as LeaderboardRouteRouteImport } from './routes/leaderboard/route'
import { Route as ListRouteRouteImport } from './routes/list/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as PacksRouteRouteImport } from './routes/packs/route'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SubmissionsRouteRouteImport } from './routes/submissions/route'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedClanRouteRouteImport } from './routes/_authenticated/clan/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedStaffRouteRouteImport } from './routes/_authenticated/staff/route'
import { Route as GamesAlphabetRouteRouteImport } from './routes/games/alphabet/route'
import { Route as GamesAredleRouteRouteImport } from './routes/games/aredle/route'
import { Route as GamesBountyBoardRouteRouteImport } from './routes/games/bounty-board/route'
import { Route as GamesHigherLowerRouteRouteImport } from './routes/games/higher-lower/route'
import { Route as GamesRouletteRouteRouteImport } from './routes/games/roulette/route'
import { Route as GamesWheelSpinnerRouteRouteImport } from './routes/games/wheel-spinner/route'
import { Route as LeaderboardIndexRouteImport } from './routes/leaderboard/index'
import { Route as ListIndexRouteImport } from './routes/list/index'
import { Route as ListLevelidRouteRouteImport } from './routes/list/$levelid/route'
import { Route as PacksIndexRouteImport } from './routes/packs/index'
import { Route as PacksPackidRouteRouteImport } from './routes/packs/$packid/route'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as ProfileClanRouteRouteImport } from './routes/profile/clan/route'
import { Route as ProfileCountryRouteRouteImport } from './routes/profile/country/route'
import { Route as ProfileUserRouteRouteImport } from './routes/profile/user/route'
import { Route as AuthenticatedStaffIndexRouteImport } from './routes/_authenticated/staff/index'
import { Route as AuthenticatedStaffMergesLayoutRouteRouteImport } from './routes/_authenticated/staff/_mergesLayout/route'
import { Route as AuthenticatedStaffRecordsLayoutRouteRouteImport } from './routes/_authenticated/staff/_recordsLayout/route'
import { Route as AuthenticatedStaffSubmissionsLayoutRouteRouteImport } from './routes/_authenticated/staff/_submissionsLayout/route'
import { Route as AuthenticatedStaffClansRouteRouteImport } from './routes/_authenticated/staff/clans/route'
import { Route as AuthenticatedStaffRolesRouteRouteImport } from './routes/_authenticated/staff/roles/route'
import { Route as AuthenticatedStaffShiftsRouteRouteImport } from './routes/_authenticated/staff/shifts/route'
import { Route as AuthenticatedStaffStatsRouteRouteImport } from './routes/_authenticated/staff/stats/route'
import { Route as AuthenticatedStaffUsersRouteRouteImport } from './routes/_authenticated/staff/users/route'
import { Route as GamesBountyBoardIndexRouteImport } from './routes/games/bounty-board/index'
import { Route as GamesBountyBoardBountyidRouteRouteImport } from './routes/games/bounty-board/$bountyid/route'
import { Route as ProfileClanClanidRouteImport } from './routes/profile/clan/$clanid'
import { Route as ProfileCountryCountryRouteImport } from './routes/profile/country/$country'
import { Route as ProfileUserUseridRouteImport } from './routes/profile/user/$userid'
import { Route as AuthenticatedStaffStatsIndexRouteImport } from './routes/_authenticated/staff/stats/index'
import { Route as AuthenticatedStaffStatsUseridRouteRouteImport } from './routes/_authenticated/staff/stats/$userid/route'
import { Route as AuthenticatedStaffMergesLayoutMergesIndexRouteRouteImport } from './routes/_authenticated/staff/_mergesLayout/merges/index/route'
import { Route as AuthenticatedStaffMergesLayoutMergesRequestidRouteRouteImport } from './routes/_authenticated/staff/_mergesLayout/merges/$requestid/route'
import { Route as AuthenticatedStaffMergesLayoutMergesDirectRouteRouteImport } from './routes/_authenticated/staff/_mergesLayout/merges/direct/route'
import { Route as AuthenticatedStaffRecordsLayoutRecordsIndexRouteRouteImport } from './routes/_authenticated/staff/_recordsLayout/records/index/route'
import { Route as AuthenticatedStaffRecordsLayoutRecordsRecordidRouteRouteImport } from './routes/_authenticated/staff/_recordsLayout/records/$recordid/route'
import { Route as AuthenticatedStaffSubmissionsLayoutSubmissionsIndexRouteRouteImport } from './routes/_authenticated/staff/_submissionsLayout/submissions/index/route'
import { Route as AuthenticatedStaffSubmissionsLayoutSubmissionsSubmissionidRouteRouteImport } from './routes/_authenticated/staff/_submissionsLayout/submissions/$submissionid/route'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const GuidelinesRouteRoute = GuidelinesRouteRouteImport.update({
            id: '/guidelines',path: '/guidelines',getParentRoute: () => rootRouteImport
          })
const LeaderboardRouteRoute = LeaderboardRouteRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const ListRouteRoute = ListRouteRouteImport.update({
            id: '/list',path: '/list',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const PacksRouteRoute = PacksRouteRouteImport.update({
            id: '/packs',path: '/packs',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SubmissionsRouteRoute = SubmissionsRouteRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedClanRouteRoute = AuthenticatedClanRouteRouteImport.update({
            id: '/clan',path: '/clan',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRouteRoute = AuthenticatedSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStaffRouteRoute = AuthenticatedStaffRouteRouteImport.update({
            id: '/staff',path: '/staff',getParentRoute: () => AuthenticatedRouteRoute
          })
const GamesAlphabetRouteRoute = GamesAlphabetRouteRouteImport.update({
            id: '/games/alphabet',path: '/games/alphabet',getParentRoute: () => rootRouteImport
          })
const GamesAredleRouteRoute = GamesAredleRouteRouteImport.update({
            id: '/games/aredle',path: '/games/aredle',getParentRoute: () => rootRouteImport
          })
const GamesBountyBoardRouteRoute = GamesBountyBoardRouteRouteImport.update({
            id: '/games/bounty-board',path: '/games/bounty-board',getParentRoute: () => rootRouteImport
          })
const GamesHigherLowerRouteRoute = GamesHigherLowerRouteRouteImport.update({
            id: '/games/higher-lower',path: '/games/higher-lower',getParentRoute: () => rootRouteImport
          })
const GamesRouletteRouteRoute = GamesRouletteRouteRouteImport.update({
            id: '/games/roulette',path: '/games/roulette',getParentRoute: () => rootRouteImport
          })
const GamesWheelSpinnerRouteRoute = GamesWheelSpinnerRouteRouteImport.update({
            id: '/games/wheel-spinner',path: '/games/wheel-spinner',getParentRoute: () => rootRouteImport
          })
const LeaderboardIndexRoute = LeaderboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LeaderboardRouteRoute
          })
const ListIndexRoute = ListIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ListRouteRoute
          })
const ListLevelidRouteRoute = ListLevelidRouteRouteImport.update({
            id: '/$levelid',path: '/$levelid',getParentRoute: () => ListRouteRoute
          })
const PacksIndexRoute = PacksIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PacksRouteRoute
          })
const PacksPackidRouteRoute = PacksPackidRouteRouteImport.update({
            id: '/$packid',path: '/$packid',getParentRoute: () => PacksRouteRoute
          })
const ProfileIndexRoute = ProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => rootRouteImport
          })
const ProfileClanRouteRoute = ProfileClanRouteRouteImport.update({
            id: '/profile/clan',path: '/profile/clan',getParentRoute: () => rootRouteImport
          })
const ProfileCountryRouteRoute = ProfileCountryRouteRouteImport.update({
            id: '/profile/country',path: '/profile/country',getParentRoute: () => rootRouteImport
          })
const ProfileUserRouteRoute = ProfileUserRouteRouteImport.update({
            id: '/profile/user',path: '/profile/user',getParentRoute: () => rootRouteImport
          })
const AuthenticatedStaffIndexRoute = AuthenticatedStaffIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const AuthenticatedStaffMergesLayoutRouteRoute = AuthenticatedStaffMergesLayoutRouteRouteImport.update({
            id: '/_mergesLayout',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const AuthenticatedStaffRecordsLayoutRouteRoute = AuthenticatedStaffRecordsLayoutRouteRouteImport.update({
            id: '/_recordsLayout',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const AuthenticatedStaffSubmissionsLayoutRouteRoute = AuthenticatedStaffSubmissionsLayoutRouteRouteImport.update({
            id: '/_submissionsLayout',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const AuthenticatedStaffClansRouteRoute = AuthenticatedStaffClansRouteRouteImport.update({
            id: '/clans',path: '/clans',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const AuthenticatedStaffRolesRouteRoute = AuthenticatedStaffRolesRouteRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const AuthenticatedStaffShiftsRouteRoute = AuthenticatedStaffShiftsRouteRouteImport.update({
            id: '/shifts',path: '/shifts',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const AuthenticatedStaffStatsRouteRoute = AuthenticatedStaffStatsRouteRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const AuthenticatedStaffUsersRouteRoute = AuthenticatedStaffUsersRouteRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedStaffRouteRoute
          })
const GamesBountyBoardIndexRoute = GamesBountyBoardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GamesBountyBoardRouteRoute
          })
const GamesBountyBoardBountyidRouteRoute = GamesBountyBoardBountyidRouteRouteImport.update({
            id: '/$bountyid',path: '/$bountyid',getParentRoute: () => GamesBountyBoardRouteRoute
          })
const ProfileClanClanidRoute = ProfileClanClanidRouteImport.update({
            id: '/$clanid',path: '/$clanid',getParentRoute: () => ProfileClanRouteRoute
          })
const ProfileCountryCountryRoute = ProfileCountryCountryRouteImport.update({
            id: '/$country',path: '/$country',getParentRoute: () => ProfileCountryRouteRoute
          })
const ProfileUserUseridRoute = ProfileUserUseridRouteImport.update({
            id: '/$userid',path: '/$userid',getParentRoute: () => ProfileUserRouteRoute
          })
const AuthenticatedStaffStatsIndexRoute = AuthenticatedStaffStatsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedStaffStatsRouteRoute
          })
const AuthenticatedStaffStatsUseridRouteRoute = AuthenticatedStaffStatsUseridRouteRouteImport.update({
            id: '/$userid',path: '/$userid',getParentRoute: () => AuthenticatedStaffStatsRouteRoute
          })
const AuthenticatedStaffMergesLayoutMergesIndexRouteRoute = AuthenticatedStaffMergesLayoutMergesIndexRouteRouteImport.update({
            id: '/merges/',path: '/merges',getParentRoute: () => AuthenticatedStaffMergesLayoutRouteRoute
          })
const AuthenticatedStaffMergesLayoutMergesRequestidRouteRoute = AuthenticatedStaffMergesLayoutMergesRequestidRouteRouteImport.update({
            id: '/merges/$requestid',path: '/merges/$requestid',getParentRoute: () => AuthenticatedStaffMergesLayoutRouteRoute
          })
const AuthenticatedStaffMergesLayoutMergesDirectRouteRoute = AuthenticatedStaffMergesLayoutMergesDirectRouteRouteImport.update({
            id: '/merges/direct',path: '/merges/direct',getParentRoute: () => AuthenticatedStaffMergesLayoutRouteRoute
          })
const AuthenticatedStaffRecordsLayoutRecordsIndexRouteRoute = AuthenticatedStaffRecordsLayoutRecordsIndexRouteRouteImport.update({
            id: '/records/',path: '/records',getParentRoute: () => AuthenticatedStaffRecordsLayoutRouteRoute
          })
const AuthenticatedStaffRecordsLayoutRecordsRecordidRouteRoute = AuthenticatedStaffRecordsLayoutRecordsRecordidRouteRouteImport.update({
            id: '/records/$recordid',path: '/records/$recordid',getParentRoute: () => AuthenticatedStaffRecordsLayoutRouteRoute
          })
const AuthenticatedStaffSubmissionsLayoutSubmissionsIndexRouteRoute = AuthenticatedStaffSubmissionsLayoutSubmissionsIndexRouteRouteImport.update({
            id: '/submissions/',path: '/submissions',getParentRoute: () => AuthenticatedStaffSubmissionsLayoutRouteRoute
          })
const AuthenticatedStaffSubmissionsLayoutSubmissionsSubmissionidRouteRoute = AuthenticatedStaffSubmissionsLayoutSubmissionsSubmissionidRouteRouteImport.update({
            id: '/submissions/$submissionid',path: '/submissions/$submissionid',getParentRoute: () => AuthenticatedStaffSubmissionsLayoutRouteRoute
          })





const AuthenticatedStaffMergesLayoutRouteRouteChildren = {
  AuthenticatedStaffMergesLayoutMergesIndexRouteRoute: AuthenticatedStaffMergesLayoutMergesIndexRouteRoute,AuthenticatedStaffMergesLayoutMergesRequestidRouteRoute: AuthenticatedStaffMergesLayoutMergesRequestidRouteRoute,AuthenticatedStaffMergesLayoutMergesDirectRouteRoute: AuthenticatedStaffMergesLayoutMergesDirectRouteRoute
}

const AuthenticatedStaffMergesLayoutRouteRouteWithChildren = AuthenticatedStaffMergesLayoutRouteRoute._addFileChildren(AuthenticatedStaffMergesLayoutRouteRouteChildren)




const AuthenticatedStaffRecordsLayoutRouteRouteChildren = {
  AuthenticatedStaffRecordsLayoutRecordsIndexRouteRoute: AuthenticatedStaffRecordsLayoutRecordsIndexRouteRoute,AuthenticatedStaffRecordsLayoutRecordsRecordidRouteRoute: AuthenticatedStaffRecordsLayoutRecordsRecordidRouteRoute
}

const AuthenticatedStaffRecordsLayoutRouteRouteWithChildren = AuthenticatedStaffRecordsLayoutRouteRoute._addFileChildren(AuthenticatedStaffRecordsLayoutRouteRouteChildren)




const AuthenticatedStaffSubmissionsLayoutRouteRouteChildren = {
  AuthenticatedStaffSubmissionsLayoutSubmissionsIndexRouteRoute: AuthenticatedStaffSubmissionsLayoutSubmissionsIndexRouteRoute,AuthenticatedStaffSubmissionsLayoutSubmissionsSubmissionidRouteRoute: AuthenticatedStaffSubmissionsLayoutSubmissionsSubmissionidRouteRoute
}

const AuthenticatedStaffSubmissionsLayoutRouteRouteWithChildren = AuthenticatedStaffSubmissionsLayoutRouteRoute._addFileChildren(AuthenticatedStaffSubmissionsLayoutRouteRouteChildren)




const AuthenticatedStaffStatsRouteRouteChildren = {
  AuthenticatedStaffStatsUseridRouteRoute: AuthenticatedStaffStatsUseridRouteRoute,AuthenticatedStaffStatsIndexRoute: AuthenticatedStaffStatsIndexRoute
}

const AuthenticatedStaffStatsRouteRouteWithChildren = AuthenticatedStaffStatsRouteRoute._addFileChildren(AuthenticatedStaffStatsRouteRouteChildren)



const AuthenticatedStaffRouteRouteChildren = {
  AuthenticatedStaffMergesLayoutRouteRoute: AuthenticatedStaffMergesLayoutRouteRouteWithChildren,AuthenticatedStaffRecordsLayoutRouteRoute: AuthenticatedStaffRecordsLayoutRouteRouteWithChildren,AuthenticatedStaffSubmissionsLayoutRouteRoute: AuthenticatedStaffSubmissionsLayoutRouteRouteWithChildren,AuthenticatedStaffClansRouteRoute: AuthenticatedStaffClansRouteRoute,AuthenticatedStaffRolesRouteRoute: AuthenticatedStaffRolesRouteRoute,AuthenticatedStaffShiftsRouteRoute: AuthenticatedStaffShiftsRouteRoute,AuthenticatedStaffStatsRouteRoute: AuthenticatedStaffStatsRouteRouteWithChildren,AuthenticatedStaffUsersRouteRoute: AuthenticatedStaffUsersRouteRoute,AuthenticatedStaffIndexRoute: AuthenticatedStaffIndexRoute
}

const AuthenticatedStaffRouteRouteWithChildren = AuthenticatedStaffRouteRoute._addFileChildren(AuthenticatedStaffRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedClanRouteRoute: AuthenticatedClanRouteRoute,AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRoute,AuthenticatedStaffRouteRoute: AuthenticatedStaffRouteRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const LeaderboardRouteRouteChildren = {
  LeaderboardIndexRoute: LeaderboardIndexRoute
}

const LeaderboardRouteRouteWithChildren = LeaderboardRouteRoute._addFileChildren(LeaderboardRouteRouteChildren)




const ListRouteRouteChildren = {
  ListLevelidRouteRoute: ListLevelidRouteRoute,ListIndexRoute: ListIndexRoute
}

const ListRouteRouteWithChildren = ListRouteRoute._addFileChildren(ListRouteRouteChildren)




const PacksRouteRouteChildren = {
  PacksPackidRouteRoute: PacksPackidRouteRoute,PacksIndexRoute: PacksIndexRoute
}

const PacksRouteRouteWithChildren = PacksRouteRoute._addFileChildren(PacksRouteRouteChildren)




const GamesBountyBoardRouteRouteChildren = {
  GamesBountyBoardBountyidRouteRoute: GamesBountyBoardBountyidRouteRoute,GamesBountyBoardIndexRoute: GamesBountyBoardIndexRoute
}

const GamesBountyBoardRouteRouteWithChildren = GamesBountyBoardRouteRoute._addFileChildren(GamesBountyBoardRouteRouteChildren)




const ProfileClanRouteRouteChildren = {
  ProfileClanClanidRoute: ProfileClanClanidRoute
}

const ProfileClanRouteRouteWithChildren = ProfileClanRouteRoute._addFileChildren(ProfileClanRouteRouteChildren)




const ProfileCountryRouteRouteChildren = {
  ProfileCountryCountryRoute: ProfileCountryCountryRoute
}

const ProfileCountryRouteRouteWithChildren = ProfileCountryRouteRoute._addFileChildren(ProfileCountryRouteRouteChildren)




const ProfileUserRouteRouteChildren = {
  ProfileUserUseridRoute: ProfileUserUseridRoute
}

const ProfileUserRouteRouteWithChildren = ProfileUserRouteRoute._addFileChildren(ProfileUserRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,GuidelinesRouteRoute: GuidelinesRouteRoute,LeaderboardRouteRoute: LeaderboardRouteRouteWithChildren,ListRouteRoute: ListRouteRouteWithChildren,PacksRouteRoute: PacksRouteRouteWithChildren,SubmissionsRouteRoute: SubmissionsRouteRoute,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,GamesAlphabetRouteRoute: GamesAlphabetRouteRoute,GamesAredleRouteRoute: GamesAredleRouteRoute,GamesBountyBoardRouteRoute: GamesBountyBoardRouteRouteWithChildren,GamesHigherLowerRouteRoute: GamesHigherLowerRouteRoute,GamesRouletteRouteRoute: GamesRouletteRouteRoute,GamesWheelSpinnerRouteRoute: GamesWheelSpinnerRouteRoute,ProfileClanRouteRoute: ProfileClanRouteRouteWithChildren,ProfileCountryRouteRoute: ProfileCountryRouteRouteWithChildren,ProfileUserRouteRoute: ProfileUserRouteRouteWithChildren,ProfileIndexRoute: ProfileIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)